module.exports = __webpack_public_path__ + "135d0c86322f6763fb5631794b8af510.svg";